import { IPositionUserRuleDictionaryApi } from '@/types';

export class PositionUserRuleDictionaryItem {
    id: number;
    name: string;

    constructor(data: IPositionUserRuleDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
    }
}
